// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { User } from "./User";
import { UserFromJSON, UserFromJSONTyped, UserToJSON, UserToJSONTyped } from "./User";

/**
 *
 * @export
 * @interface DatasetVersionRead
 */
export interface DatasetVersionRead {
  /**
   *
   */
  createdAt: Date;
  /**
   *
   */
  updatedAt: Date;
  /**
   *
   */
  datasetId: string;
  /**
   * Version number of the dataset
   */
  versionNumber: number;
  /**
   *
   */
  fileDescriptorId?: string | null;
  /**
   * Reference to the version in the storage system
   */
  storeRef: string;
  /**
   *
   */
  description?: string | null;
  /**
   *
   */
  committedAt?: Date | null;
  /**
   *
   */
  committedBy: User;
}

/**
 * Check if a given object implements the DatasetVersionRead interface.
 */
export function instanceOfDatasetVersionRead(value: object): value is DatasetVersionRead {
  if (
    (!("createdAt" in (value as Record<string, any>)) &&
      !("created_at" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["createdAt"] === undefined &&
      (value as Record<string, any>)["created_at"] === undefined)
  )
    return false;
  if (
    (!("updatedAt" in (value as Record<string, any>)) &&
      !("updated_at" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["updatedAt"] === undefined &&
      (value as Record<string, any>)["updated_at"] === undefined)
  )
    return false;
  if (
    (!("datasetId" in (value as Record<string, any>)) &&
      !("dataset_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["datasetId"] === undefined &&
      (value as Record<string, any>)["dataset_id"] === undefined)
  )
    return false;
  if (
    (!("versionNumber" in (value as Record<string, any>)) &&
      !("version_number" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["versionNumber"] === undefined &&
      (value as Record<string, any>)["version_number"] === undefined)
  )
    return false;
  if (
    (!("storeRef" in (value as Record<string, any>)) &&
      !("store_ref" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["storeRef"] === undefined &&
      (value as Record<string, any>)["store_ref"] === undefined)
  )
    return false;
  if (
    (!("committedBy" in (value as Record<string, any>)) &&
      !("committed_by" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["committedBy"] === undefined &&
      (value as Record<string, any>)["committed_by"] === undefined)
  )
    return false;
  return true;
}

export function DatasetVersionReadFromJSON(json: any): DatasetVersionRead {
  return DatasetVersionReadFromJSONTyped(json, false);
}

export function DatasetVersionReadFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): DatasetVersionRead {
  if (json == null) {
    return json;
  }
  return {
    createdAt: json["created_at"] == null ? json["created_at"] : parseDateTime(json["created_at"]),
    updatedAt: json["updated_at"] == null ? json["updated_at"] : parseDateTime(json["updated_at"]),
    datasetId: json["dataset_id"],
    versionNumber: json["version_number"],
    fileDescriptorId:
      json["file_descriptor_id"] === undefined
        ? undefined
        : json["file_descriptor_id"] === null
        ? null
        : json["file_descriptor_id"],
    storeRef: json["store_ref"],
    description:
      json["description"] === undefined
        ? undefined
        : json["description"] === null
        ? null
        : json["description"],
    committedAt:
      json["committed_at"] === undefined
        ? undefined
        : json["committed_at"] === null
        ? null
        : parseDateTime(json["committed_at"]),
    committedBy: UserFromJSON(json["committed_by"]),
  };
}

export function DatasetVersionReadToJSON(json: any): DatasetVersionRead {
  return DatasetVersionReadToJSONTyped(json, false);
}

export function DatasetVersionReadToJSONTyped(
  value?: DatasetVersionRead | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    created_at:
      value["createdAt"] == null ? value["createdAt"] : serializeDateTime(value["createdAt"]),
    updated_at:
      value["updatedAt"] == null ? value["updatedAt"] : serializeDateTime(value["updatedAt"]),
    dataset_id: value["datasetId"],
    version_number: value["versionNumber"],
    file_descriptor_id: value["fileDescriptorId"],
    store_ref: value["storeRef"],
    description: value["description"],
    committed_at:
      value["committedAt"] == null ? value["committedAt"] : serializeDateTime(value["committedAt"]),
    committed_by: UserToJSON(value["committedBy"]),
  };
}
